<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧景区</h2>
        <h3>景区售检票系统</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview mb100">
        <!-- <div class="fl">
          <img src="../../../assets/img/smart/zhdp_summary_Image.png" alt="" />
        </div> -->
        <div>
          <h2>景区售检票系统</h2>
          <p>
            智慧景区售检票管理系统是景区票务系统的总称，属于景区的核心业务系统，利用现代的科技手段实现景区门票的售检验退智能化管理，主要实现 景区门票的票类管理、库存管理、售票渠道管理、售票方式管理、会员管理、员工管理、取票兑票、退票、查验门票、旅行社管理、明细报表、统计报
            表、趋势分析、检票管理等。通过售检票管理系统实现智慧景区线上与线下各门票业务渠道的售检票管理，主要包括：窗口、自助终端、移动端、门户 端、小程序端、旅行社、OTA渠道、活动渠道等。
          </p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix">
        <li>
          <h2>售票优势</h2>
          <p>完善分销体系，开拓景区销售渠道</p>
        </li>
        <li>
          <h2>换票优势</h2>
          <p>节省步骤，入园更高效</p>
        </li>
        <li>
          <h2>检票优势</h2>
          <p>无人值守，码上入园</p>
        </li>
        <li>
          <h2>数据管理优势</h2>
          <p>自动生成，实时反馈</p>
        </li>
      </ul>
    </div>
    <!-- 方案架构 -->
    <div class="container clearfix">
      <div class="smart-title">方案架构</div>
      <div class="smart-schema">
        <img src="../../../assets/img/smart/framework1_Image.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'scenicfarsCollection',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/backgroundscenic_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 160px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
